import clsx from 'clsx';
import React, { ReactElement, ReactNode } from 'react';

import Card from '@/src/components/common/Elements/Card/Card';

type SettingsCardProps = {
  id?: string;
  title?: string;
  isReports?: boolean;
  children: ReactNode;
  actionButton?: ReactElement;
  footerContent?: ReactElement;
};

const SettingsCard = ({
  id,
  title,
  children,
  isReports = false,
  actionButton,
  footerContent,
}: SettingsCardProps) => {
  return (
    <Card
      id={id}
      className={clsx(
        'tw-bg-white',
        'tw-border-solid tw-border-[1px] tw-border-cfo-grey-500 tw-rounded-[5px]',
        'tw-box-border',
        'tw-shadow-[2px_4px_5px_rgba(0,0,0,0.1)]',
        'tw-mt-[24px]'
      )}
    >
      <div
        className={clsx(
          'settingsCard--header',
          'tw-flex tw-items-center tw-justify-between',
          'tw-px-[30px] tw-py-[12px]',
          'tw-border-solid tw-border-b-[1px] tw-border-cfo-grey-500 tw-rounded-[5px]'
        )}
        style={{ justifyContent: isReports ? 'flex-start' : 'space-between' }}
      >
        <h4
          className={clsx(
            '!tw-text-[18px] tw-text-cfo-black tw-font-brandonTextMedium',
            'tw-py-[10px]'
          )}
        >
          {title}
        </h4>

        {/* props for respective header actions needed */}
        {actionButton && actionButton}
      </div>

      <div className={clsx('settingsCard--body')}>{children}</div>

      {/* props for respective footer contents if needed */}
      {footerContent && footerContent}
    </Card>
  );
};

export default SettingsCard;
